import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'
import '@/sass/fonts.sass'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1F4680',
        check: '#009688',
        success: colors.green.accent4,
        error: colors.red.darken1,
        warning: colors.orange.accent4,
        tileMobile: '#F1F3F5',
        tileDesktop: '#FFFFFF',
        backgroundDesktop: colors.grey.lighten5,
        backgroundMobile: '#FFFFFF',
      },
    },
  },
})

export default vuetify
